import { useContext } from "react";
import { AppContext } from "../App";
import writingEssentials from "../assets/writting_essentials.png";
import paper from "../assets/paper.png";
import filing from "../assets/filing.png";
import deskAccessories from "../assets/desk_accessories.png";
import towelDispenser from "../assets/towel_dispenser.png";
import toiletSeatSanitizer from "../assets/toilet_seat_sanitizer.png";
import sanitaryBins from "../assets/sanitary_bins.png";
import liquidSoapDispenser from "../assets/liquid_soap_dispenser.png";
import airFreshener from "../assets/air_freshener.png";
import tabletopNapkins from "../assets/tabletop_napkins.png";
import icon10cs from "../assets/icon_10cs.png";
import actellic50ec from "../assets/actellic_50ec.png";
import actellic300cs from "../assets/actellic_300cs.png";
import aerosol from "../assets/aerosol.png";
import tatuaZyrox from "../assets/tatua_zyrox.png";
import fumigation from "../assets/fumigation.png";
import consumables from "../assets/consumables.jpg";
import fertilizers from "../assets/fertilizers.jpg";
import seeds from "../assets/seeds.jpg";
import regulators from "../assets/regulators.jpg";
import procurement from "../assets/procurement.jpg";

export const serviceMenuGroups = [
  {
    title: "Public Health Products & Management",
    slug: "public-health-products-management",
    menuTitle: "Public Health Products & Management",
    items: [
      "Pest control products",
      "Fumigation products",
      "Repellent products",
      "LLINs products",
    ],
  },
  {
    title: "Hygiene Specialized Household Items",
    slug: "hygiene-specialized-household-items",
    menuTitle: "Hygiene Specialized Household Items",
    items: ["Tissues products", "Sanitary wares products"],
  },
  {
    title: "Stationaries",
    slug: "stationaries",
    menuTitle: "Stationaries",
    items: ["Office supplies & equipment products"],
  },
  {
    title: "Agro-Chemical Products",
    slug: "agro-chemical-products",
    menuTitle: "Agro-Chemical Products",
    items: [
      "Insecticides",
      "Herbicides",
      "Fertilizers",
      "Seeds",
      "Plant Growth Regulators (PGR)",
    ],
  },
  {
    title: "General Trading",
    slug: "general-trading",
    menuTitle: "General Trading",
    items: ["Supply of consumable & non-consumables"],
  },
];

export const serviceCategories = [
  {
    slug: "public-health-products-management",
    title: "Public Health Products & Management",
    navTitle: "Public Health",
    heroImage: fumigation,
    summary:
      "Integrated public health sourcing and product management for institutions, field operations, and commercial environments.",
    intro:
      "We support public health operations with dependable product sourcing, supply coordination, and practical management support for critical pest and vector control programs.",
    body: "This category covers pest control products, fumigation products, repellent solutions, and LLINs products for organizations that need reliable, compliant, and professionally supplied public health materials.",
    highlights: [
      "Pest control products",
      "Fumigation products",
      "Repellent products",
      "LLINs products",
    ],
    products: [
      {
        title: "Pest Control Products",
        image: icon10cs,
        description:
          "Industry-ready pest control solutions for institutions, facilities, and managed intervention programs.",
      },
      {
        title: "Fumigation Products",
        image: actellic50ec,
        description:
          "Professional fumigation supply options designed for effective treatment planning and reliable field performance.",
      },
      {
        title: "Repellent Products",
        image: aerosol,
        description:
          "Repellent formulations that help protect households, teams, and shared environments from biting insects and pests.",
      },
      {
        title: "LLINs Products",
        image: tatuaZyrox,
        description:
          "Long-lasting insecticidal net solutions that support household protection and public health distribution efforts.",
      },
      {
        title: "Vector Control Support Products",
        image: actellic300cs,
        description:
          "Complementary products and supply support for structured mosquito and vector management programs.",
      },
    ],
  },
  {
    slug: "hygiene-specialized-household-items",
    title: "Hygiene Specialized Household Items",
    navTitle: "Hygiene",
    heroImage: towelDispenser,
    summary:
      "Professional hygiene and household supply solutions for workplaces, facilities, institutions, and managed spaces.",
    intro:
      "We supply hygiene-focused household items that help organizations maintain clean, safe, and well-supported daily environments.",
    body: "This category includes tissue products and sanitary wares products selected for practical use in offices, commercial facilities, institutions, and high-traffic shared spaces.",
    highlights: ["Tissues products", "Sanitary wares products"],
    products: [
      {
        title: "Tissue Products",
        image: tabletopNapkins,
        description:
          "Tissue ranges for daily operational use, hospitality support, and managed hygiene supply programs.",
      },
      {
        title: "Sanitary Wares Products",
        image: sanitaryBins,
        description:
          "Sanitary accessories and washroom support products for cleaner and more functional shared spaces.",
      },
      {
        title: "Soap & Dispenser Systems",
        image: liquidSoapDispenser,
        description:
          "Managed hygiene dispensing solutions that improve usability and presentation in professional settings.",
      },
      {
        title: "Washroom Support Items",
        image: toiletSeatSanitizer,
        description:
          "Specialized support items that reinforce cleanliness, comfort, and confidence in washroom environments.",
      },
      {
        title: "Air Care & Surface Support",
        image: airFreshener,
        description:
          "Finishing products that help maintain freshness and overall hygiene standards in occupied spaces.",
      },
    ],
  },
  {
    slug: "agro-chemical-products",
    title: "Agro-Chemical Products",
    navTitle: "Agro-Chemical",
    heroImage: actellic300cs,
    summary:
      "Targeted agro-chemical sourcing for insecticides, herbicides, fertilizers, seeds, and growth regulators.",
    intro:
      "A dedicated category for agricultural and crop protection products with dependable supply coordination.",
    body: "This category covers insecticides, herbicides, fertilizers, seeds, and plant growth regulators designed to support agricultural operations and crop management.",
    highlights: [
      "Insecticides",
      "Herbicides",
      "Fertilizers",
      "Seeds",
      "Plant Growth Regulators (PGR)",
    ],
    products: [
      {
        title: "Insecticides",
        image: actellic50ec,
        description:
          "Sourcing dependable insect control formulations for agricultural and institutional needs.",
      },
      {
        title: "Herbicides",
        image: aerosol,
        description:
          "Herbicide supply options for managed vegetation control and crop protection applications.",
      },
      {
        title: "Fertilizers",
        image: fertilizers,
        description:
          "Fertilizer products selected for sustained crop nutrition and field performance.",
      },
      {
        title: "Seeds",
        image: seeds,
        description:
          "Seed sourcing and supply support for planting, production planning, and crop establishment.",
      },
      {
        title: "Plant Growth Regulators",
        image: regulators,
        description:
          "Growth regulator solutions for improved crop performance and production balance.",
      },
    ],
  },
  {
    slug: "stationaries",
    title: "Stationaries",
    navTitle: "Stationaries",
    heroImage: writingEssentials,
    summary:
      "Office supply and equipment sourcing for organizations that need smooth, efficient day-to-day administration.",
    intro:
      "We provide practical stationery and office support products that help teams stay organized, productive, and ready for daily operations.",
    body: "Our stationaries category covers office supplies and equipment products that keep workplaces equipped for communication, documentation, filing, and general administrative work.",
    highlights: [
      "Office supplies",
      "Office equipment",
      "Document handling",
      "Workspace support",
    ],
    products: [
      {
        title: "Writing Essentials",
        image: writingEssentials,
        description:
          "Pens, markers, notebooks, and writing tools for everyday office and institutional use.",
      },
      {
        title: "Paper Products",
        image: paper,
        description:
          "Quality paper supply for printing, photocopying, records, and routine business workflows.",
      },
      {
        title: "Filing & Storage",
        image: filing,
        description:
          "Folders, files, and practical organization materials for cleaner document management.",
      },
      {
        title: "Office Accessories & Equipment",
        image: deskAccessories,
        description:
          "Functional desktop and workspace products that support efficient office operations.",
      },
    ],
  },
  {
    slug: "general-trading",
    title: "General Trading",
    navTitle: "General Trading",
    heroImage: deskAccessories,
    summary:
      "Flexible sourcing and dependable supply support for consumable and non-consumable business requirements.",
    intro:
      "We help organizations source a broad range of general trading items through dependable procurement and distribution support.",
    body: "This category is designed for clients that need a reliable partner for supply of consumable and non-consumables, combining sourcing flexibility with professional delivery coordination.",
    highlights: [
      "Consumable supply",
      "Non-consumable supply",
      "Flexible sourcing",
      "Business support logistics",
    ],
    products: [
      {
        title: "Consumable Supply",
        image: consumables,
        description:
          "Operational consumables sourced to support continuity across offices, institutions, and managed facilities.",
      },
      {
        title: "Non-consumable Supply",
        image: deskAccessories,
        description:
          "Durable goods and reusable items selected for lasting value and dependable everyday use.",
      },
      {
        title: "Support Procurement",
        image: procurement,
        description:
          "Responsive sourcing support for special requests, recurring supply cycles, and broader operational needs.",
      },
    ],
  },
];

export function getServiceCategory(slug) {
  return serviceCategories.find((service) => service.slug === slug);
}

export default function ServicesContent() {
  const appContext = useContext(AppContext);

  return (
    <>
      <section className="vex-page-hero" data-aos="fade-up">
        <div className="container">
          <div className="vex-page-hero-shell" data-aos="fade-up">
            <p className="vex-eyebrow">Services</p>
            <h1>
              Corporate supply categories designed around how organizations
              operate.
            </h1>
            <p>
              VEX brings focused sourcing, dependable distribution, and
              responsive support into clear service categories that help clients
              buy with confidence.
            </p>
          </div>
        </div>
      </section>

      <section className="vex-section vex-section-light" data-aos="fade-up">
        <div className="container">
          <div className="vex-section-heading" data-aos="fade-up">
            <p className="vex-panel-tag">Core Categories</p>
            <h2>
              Well-structured solutions for public institutions, businesses, and
              facilities.
            </h2>
            <p>
              Each category is built to make sourcing simpler, presentation more
              professional, and delivery more dependable across the product
              groups our clients use most.
            </p>
          </div>

          <div className="row g-4">
            {serviceCategories.map((service, index) => (
              <div
                className="col-lg-6"
                key={service.slug}
                data-aos="fade-up"
                data-aos-delay={index * 80}
              >
                <article className="vex-service-card vex-service-card-large ">
                  <div className="vex-service-card-media">
                    <img src={service.heroImage} alt={service.title} />
                  </div>
                  <div className="vex-service-card-body d-flex flex-column mb-none">
                    <h2>{service.title}</h2>
                    <p>{service.intro}</p>
                    <button
                      type="button"
                      className="btn btn-primary vex-btn mt-auto"
                      onClick={() =>
                        appContext.navTo({
                          item: "services",
                          subItem: service.slug,
                        })
                      }
                    >
                      Open Category
                    </button>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
